import React from 'react';
import Form from 'src/components/Form';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import Skeleton from 'src/components/Skeleton/Skeleton';
import KeyHandoffSkeletonBody from './KeyHandoffSkeletonBody';

const KeyHandoffComponentSkeleton = () => (
  <Form
    headline="Key Pickup"
    onClose={undefined}
    onExit={undefined}
    onSubmit={undefined}
    actions={undefined}
    footer={undefined}
    strapline={undefined}
    component={
      <Row>
        <Col xs="12" md="12">
          <KeyHandoffSkeletonBody />
          <Skeleton variant="rect" width="100%" height="2.75rem" />
        </Col>
      </Row>
    }
  />
);

export default KeyHandoffComponentSkeleton;